<template>
  <div class="platform-container">
      <div class="first-page">
            <div class="top-box">
                <div class="title">飞视系列产品</div>
                <div class="content">
                    实现航线规划、起降、飞行采集、事件分析、事件推送、全景/三维生产、安全预警、报告输出等全流程自动化<br>
                    自主研发，支持客户个性化需求
                </div>
            </div>
            <tooltip class="bottom-box">  
                <!-- 触发Tooltip的元素 -->  
                <template v-slot:trigger>
                    <div class="bottom-rotate-box" @mouseover="stopRotation()" @mouseleave="startRotation()">
                        <svg-icon class="rotate-icon" icon-class="platform-1"></svg-icon>
                    </div>                    
                </template>  
                <!-- Tooltip的内容 -->  
                <template v-slot:content>  
                    产品获得2021年浙江省数字乡村最佳实践案例、2021年度浙江省城市大脑（智慧城市）场景应用优秀案例、2022年浙江省第五批数字司法好应用、2023年浙江省大综合一体化行政执法改革“最佳实践”、2022年“创客中国”浙江赛区暨“浙江好项目”中小企业创新创业大赛衢州分赛区决赛三等奖、衢州市第八届数据挖掘暨首届“钱江源”杯数据开发利用大赛三等奖等荣誉。受到中国新闻网、中国青年报、浙江日报、衢州日报等媒体的广泛报道。
                </template>  
            </tooltip> 
      </div>
      <div class="second-page">
            <div class="top-title-box">
                <div class="title-box" :style="getTitleColor(0)" @mouseover="secondHoverID = 0">
                    "综合飞一次"大屏看板
                </div>
                <div class="title-box" :style="getTitleColor(1)"  @mouseover="secondHoverID = 1">
                    业主工作台
                </div>
                <div class="title-box" :style="getTitleColor(2)" @mouseover="secondHoverID = 2">
                    飞视巡检助手
                </div>
            </div>
            <div class="slider-box">
                <div class="slider" :style="sliderStyle()"></div>
            </div> 
            <div class="medium-box">
                <img :style="{'opacity': secondHoverID === 0 ? '1' : '0'}"  :src="require('@/assets/images/platform/ScreenSignage.png')" alt="图片加载失败">
                <img :style="{'opacity': secondHoverID === 1 ? '1' : '0'}"  :src="require('@/assets/images/platform/workbench.png')" alt="图片加载失败">
                <img :style="{'opacity': secondHoverID === 2 ? '1' : '0'}"  :src="require('@/assets/images/platform/assistant.png')" alt="图片加载失败">

                <div class="play-btn" v-if="secondHoverID === 0" @mouseenter="playBtnHover = true" @mouseleave="playBtnHover = false" @click="videoVisible1 = true">
                    <img :src="require('@/assets/images/platform/play-hover.png')" alt="视频按钮加载失败" v-if="playBtnHover" >
                    <img :src="require('@/assets/images/platform/play.png')" alt="视频按钮加载失败" v-else>
                </div>
                
            </div>
            <div class="bottom-box">
                    <div class="title">{{secondContent[secondHoverID].title}}</div>
                    <div class="content">{{secondContent[secondHoverID].content1}}<br>{{secondContent[secondHoverID].content2}}</div>
            </div>
            <div class="video-container"  v-if="videoVisible1">
                <video class="video-box" src="https://flysee-business.oss-cn-hangzhou.aliyuncs.com/video/%E7%9C%8B%E6%9D%BF%E4%BB%8B%E7%BB%8D2024-%E7%AC%AC%E5%85%AD%E7%89%88%EF%BC%881.0%E5%80%8D%E9%80%9F-1080p%EF%BC%89.mp4" autoplay loop controls>
                </video>
                <img class="cancel-btn" :src="require('@/assets/images/HomePage/banner/cancel.png')" alt="关闭图标加载失败" v-if="videoVisible1" @click=" videoVisible1 = false ">    
            </div>
      </div>
      <div class="third-page" ref="thirdPage">
            <div class="top-box" ref="topBox">
                <div class="title" >产品特点</div>
                <div class="control">
                    <div class="circle" :class="{'active': currentIndex === key}"  v-for="(item,key) in 6" :key="key" @click="changeItem(key)"></div>
                </div> 
                <div class="backImg">
                    <Vanta></Vanta>
                </div>
                <div class="image-box">
                    <div v-for="(item,key) in 6" :key="key">
                        <img class="rightImg" :class="{rightImg_active : currentIndex === key}" :src="require('@/assets/images/platform/character'+ key +'.png')" alt="产品特点图片展示失败"> 
                    </div>
                </div>
            </div>
            <div class="box">
                <div class="box-background" v-for="(item,key) in characterData" :key="key">
                    <div class="item" :style="getItemStyle(key)">
                        <div class="content-box">
                            <div class="trigger"></div>
                            <div class="subtitle">{{item.title}}</div>
                            <div class="content" v-for="(subItem,id) in item.content" :key="id">
                                {{subItem}}<br>
                            </div>
                            <div v-if="item.tags" class="tag-box">
                                <div v-for="subTag in item.tags[0]" :key="subTag">
                                    <div class="tag">{{subTag}}</div>
                                </div>
                            </div>
                            <div v-if="item.tags" class="tag-box">
                                <div v-for="subTag in item.tags[1]" :key="subTag">
                                    <div class="tag">{{subTag}}</div>
                                </div>
                                <br>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
      </div>
      <div class="fourth-page">
          <div class="title">基层治理现代化 · 产品能力</div>
          <CarouselHorizontal class="bottom-box"></CarouselHorizontal>
      </div>
      <div class="fifth-page">
          <div class="title">6专利 · 22软著</div>
          <div class="image-box">
                <div class="row">
                    <div class="item" v-for="(item,key) in honor[0]" :key="key">
                        <img class="image" :src="require('@/assets/images/platform/honor/'+item+'.png')" alt="图标加载失败">
                    </div>
                </div>
                <div class="row">
                    <div class="item" v-for="(item,key) in honor[1]" :key="key">
                        <img class="image" :src="require('@/assets/images/platform/honor/'+item+'.png')" alt="图标加载失败">
                    </div>
                </div>
                <div class="row" v-if="!moreButtonVisible">
                    <div class="item" v-for="(item,key) in honor[2]" :key="key">
                        <img class="image" :src="require('@/assets/images/platform/honor/'+item+'.png')" alt="图标加载失败">
                    </div>
                </div> 
                <div class="row" v-if="!moreButtonVisible">
                    <div class="item" v-for="(item,key) in honor[3]" :key="key">
                        <img class="image" :src="require('@/assets/images/platform/honor/'+item+'.png')" alt="图标加载失败">
                    </div>
                </div>
                <el-button class="more-btn" @click="moreButtonVisible = false" v-if="moreButtonVisible">
                    <span class="btn-content">加载更多</span>
                    <svg-icon class="arrow-icon" icon-class="platform-2"></svg-icon>
                </el-button>
                
          </div>
      </div>
  </div>
</template>

<script >
import tooltip from './Tooltip.vue'
import CarouselHorizontal from './CarouselHorizontal.vue'
import Vanta from './Vanta.vue'

export default {
    name: 'Platform',
    components:{
        tooltip,CarouselHorizontal,Vanta
    },
    data(){
        return{
            videoVisible1:false,
            videoVisible2:false,
            secondHoverID:0,
            secondTitleBox:[],
            titleSpace:[],
            secondContent:[
                {title: '助力基层治理现代化，赋能巡检执法', content1:'以无人机为载体，凭借自动飞行、抓拍、识别等前端感知系统，组建起全市域“巡检一张网”',content2:'利用“智能巡检+AI感知+智慧执法”数字化手段实现部门和乡镇任务一键交办，提高数字执法和“非现场”执法能力'},
                {title: '易用智能的巡检操作平台', content1:'一站式人员、设备、任务、飞行、数据管理、智能任务管理、智能排期管理、手动调整排期日历，实现自由飞行；',content2:'fsGPT，打破传统交互方式，让操作更简单'},
                {title: '“掌上”移动智能巡检平台', content1:'精简核心功能，随时随地随心执行飞行任务、查看各类数据',content2:''},
            ],
            playBtnHover:false,
            characterData:[
                {title:'数据中心',content:['全面整合飞行状态、视频流、照片、AI识别结果以及三维、正射、全景等多种数据。','\n','最大化发挥海量数据的价值。'],img:'character0'},
                {title:'智能调度中心',content:['创建任务后，全自动起降并生产成果','多重校验及安全保障，让飞行不再有顾虑'],img:'character1'},
                {title:'全覆盖巡检',content:['独创全覆盖航线，0死角覆盖，3分钟必达','日常自动巡检全覆盖航线，365天全年飞行'],img:'character2'},
                {title:'三维底座采集',content:['拥有数据轻量化、精度高、更新高频、低成本优势','日常全覆盖自动更新三维底座','不断优化采集流程，高效构建最新的城市三维底座，保障飞行安全'],img:'character3'},
                {title:'多样化平台机场',content:['无人值守机场，全年自动起降','支持接入多品牌机型，可手动飞行，数据上传','兼容市面上所有常见挂载，满足多业务场景的个性化需求'],img:'character4'},
                {title:'智能AI',content:['自主研发多种算法，实现最大化节省人力成本'],img:'character5',tags:[['AI赋能100类巡检场景','AI实时识别','AI变化检测'],['AI托管机场','AI航线规划']]},
            ],
            currentIndex: 7,  
            lastPosiyion:0,
            isFullScreen:false,
            honor:[
                ['patent1','patent2','patent3','patent4','patent5','patent6'],
                ['copyright1','copyright2','copyright3','copyright4','copyright5','copyright6','copyright7','copyright8'],
                ['copyright9','copyright10','copyright11','copyright12','copyright13','copyright14','copyright15','copyright16'],
                ['copyright17','copyright18','copyright19','copyright20','copyright21','copyright22']
            ],
            moreButtonVisible:true,
            screenHeight:0
        }
    },
    methods:{
        stopRotation() {  
            // 当鼠标悬停时，给图片添加'paused'类来暂停动画  
            const box = this.$el.querySelector('.rotate-icon');  
            box.classList.add('paused');  
        },  
        startRotation() {  
            // 当鼠标离开时，移除'paused'类来恢复动画  
            const box = this.$el.querySelector('.rotate-icon');  
            box.classList.remove('paused');  
        },
        getTitleBox(){
            let titleBoxes = this.$el.querySelectorAll('.title-box');  
            this.secondTitleBox = Array.from(titleBoxes).map(titleBox => titleBox.offsetWidth); 
            let sum = this.secondTitleBox.reduce((sum, current) => sum + Number(current), 0);

            let space = this.$el.querySelectorAll('.top-title-box');  
            let  tmp = Array.from(space).map(space => space.offsetWidth);  
            this.titleSpace = (tmp[0] - sum) / (this.secondTitleBox.length-1);  
        },
        getTitleColor(id){
            if(id === this.secondHoverID) return 'color: ' + '#FFFFFF' ;
            return 'color: ' + '#000000bf' ;
        },
        sliderStyle() {  
            let left = 0;
            if(this.secondHoverID == 1){
                left = this.secondTitleBox[0] + this.titleSpace;
            }
            else if(this.secondHoverID == 2){
                left = this.secondTitleBox[0] + this.titleSpace + this.secondTitleBox[1] + this.titleSpace;
            }
              
            let width = this.secondTitleBox[this.secondHoverID];  
            return { marginLeft: `${left}px`, width: `${width}px` };  
        },
        handleScroll() {
            const rect = this.$refs.thirdPage.getBoundingClientRect(); 
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0; 

            // window.console.log(rect.top, rect.bottom,currentScrollY)
            if(rect.top <=0 && rect.top >= -5*this.screenHeight){
                this.$refs.topBox.classList.add('top_fix');
                this.$refs.topBox.classList.remove('top_bottom');
                this.$refs.topBox.classList.remove('top_top');


                if(this.lastPosiyion < currentScrollY){ //向下翻页
                    if(rect.top >= -1*this.screenHeight * 2/3){
                        this.currentIndex = 0;
                    }
                    else if(rect.top >= -2*this.screenHeight + 1/3 * this.screenHeight){
                        this.currentIndex = 1;
                    }
                    else if(rect.top >= -3*this.screenHeight + 1/3 * this.screenHeight){
                        this.currentIndex = 2;
                    }
                    else if(rect.top >= -4*this.screenHeight + 1/3 * this.screenHeight){
                        this.currentIndex = 3;
                    }else if(rect.top >= -5*this.screenHeight + 1/3 * this.screenHeight){
                        this.currentIndex = 4;
                    }
                    else{
                        this.currentIndex = 5;
                    }
                }
                else{ //向上翻页
                    if(rect.top >= - 1/3 * this.screenHeight){
                        this.currentIndex = 0;
                    }
                    else if(rect.top >= -1*this.screenHeight  - 1/3 * this.screenHeight){
                        this.currentIndex = 1;
                    }
                    else if(rect.top >= -2*this.screenHeight  - 1/3 * this.screenHeight){
                        this.currentIndex = 2;
                    }
                    else if(rect.top >= -3*this.screenHeight  - 1/3 * this.screenHeight){
                        this.currentIndex = 3;
                    }
                    else if(rect.top >= -4*this.screenHeight - 1/3 * this.screenHeight){
                        this.currentIndex = 4;
                    }else if(rect.top >= -5*this.screenHeight){
                        this.currentIndex = 5;
                    }
                }

            }
            else if(rect.top >= 0){
                this.currentIndex = 0;
                this.$refs.topBox.classList.add('top_top');
                this.$refs.topBox.classList.remove('top_fix');

            }
            else{
                this.currentIndex = 5;
                this.$refs.topBox.classList.add('top_bottom');
                this.$refs.topBox.classList.remove('top_fix');

            }
            this.lastPosiyion = currentScrollY;
        }, 
        changeItem(id){
            this.currentIndex = id;
            this.scrollToPosition(this.screenHeight * (id + 1) + 670);
        },
        scrollToPosition(newPosition) {  
            window.console.log('开始跳转', newPosition);  
            const scrollStep = () => {  
                const c = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;  
                window.console.log(c);  
        
                if (c < newPosition) { // 向下跳转  
                    const scrollDistance = Math.min(newPosition - c, c / 50); // 计算应该滚动的距离，不超过当前位置的10%，并且不超过到达目标位置所需的距离  
                    const ScrollPosition = c + scrollDistance; // 计算新的滚动位置  
                    window.scrollTo(0, ScrollPosition);  
        
                    if (ScrollPosition < newPosition) {  
                        window.requestAnimationFrame(scrollStep); // 如果还未到达目标位置，继续滚动  
                    }  
                } else if (c > newPosition) { // 向上跳转（这部分已存在）  
                    const ScrollPosition = Math.max(0, c - c / 50); // 滚动一小段距离  
                    window.scrollTo(0, ScrollPosition);  
        
                    if (ScrollPosition > newPosition) {  
                        window.requestAnimationFrame(scrollStep); // 如果还未到达目标位置，继续滚动  
                    }  
                }  
                // 如果c === newPosition，则不需要任何操作，因为已经到达目标位置  
            };  
        
            scrollStep();  
        },
        getItemStyle(id){
            if(this.currentIndex === id){
                return { opacity : '1'};
            }
            else{
                return { opacity : '0.4'}
            }
        }
    },
    watch:{
        secondHoverID() {  
            this.$forceUpdate();
        }
    },
    mounted(){
        this.getTitleBox();
        this.screenHeight = window.innerHeight;
        window.addEventListener('scroll', this.handleScroll); 
    },
    beforeDestroy() {  
        window.removeEventListener('scroll', this.handleScroll);  
    },
}
</script>

<style lang="scss" scoped>
.platform-container{
    width: 100vw;
    height: 100%;
    letter-spacing: 0px;
    color: #FFFFFF;
    background-color: #000000;
    padding: 0px;
    margin: 0;
    overflow-x: hidden;

    .first-page{
        width: 100vw;
        height: 100vh;
        background-image: url('@/assets/images/platform/background1.jpg');  
        background-size: cover;
        background-position: center;
        position: relative;
        text-align: center;
        display: flex;
        flex-direction: column;
        .top-box{
            position: absolute;
            width: 100%;
            height: 158px;
            top: vh(200);
            left: 50%;
            transform: translateX(-50%);
            .title{
                height: 64px;
                font-weight: 500;
                font-size: 42px;
                line-height: 64px;
                margin-bottom: 22px;
            }  
            .content{
                width: 100%;
                height: 72px;
                font-weight: 400;
                font-size: 18px;
                letter-spacing: 0;
                line-height: 36px;
            }  
        }
        .bottom-box{
            position: absolute;
            width: 48px;
            height: 48px;
            bottom: vh(160);
            border-radius: 50%;
            left: 50%;
            transform: translateX(-50%);
            .bottom-rotate-box{
                position: absolute;
                width: 48px;
                height: 48px;
                background: #ffffff;
                border-radius: 50%;
                left: 50%;
                transform: translateX(-50%);
                display: flex;
                justify-content:center;
                align-items: center;

                &:hover{
                    cursor: pointer;
                }

                .rotate-icon{
                    width: 24px;
                    height: 24px;
                    
                    //旋转动画
                    animation: rotate 3s linear infinite;
                }

                @keyframes rotate {  
                    from {  
                        transform: rotate(0deg);  
                    }  
                    to {  
                        transform: rotate(360deg);  
                    }  
                }
                // 控制动画暂停
                .paused {  
                    animation-play-state: paused;  
                } 
            }
        }
    }
    .second-page{
        width: 100vw;
        height: 670px;
        background-color: #FFFFFF;
        display: flex;
        flex-direction: column;
        align-items:center;
        position: relative;
        z-index: 3;

        .top-title-box{
            position: absolute;
            z-index: 3;
            top: 48px;
            max-width: 520px;
            width: calc(100% - 80px);
            height: 48px;
            transform: translateX(-6%);
            display: flex;
            flex-direction: row;
            justify-content:space-between;

            .title-box{
                height: 48px;
                padding: 12px 24px;
                display: flex;
                align-items:center;
                justify-content: center;

                font-weight: 500;
                font-size: 16px;
                color: #000000bf;
                text-align: center;
                line-height: 24px;
                transition: color 0.3s;
            }
        }
        .slider-box{
            position: absolute;
            z-index: 2;
            top: 48px;
            transform: translateX(-6%);
            height: 48px;
            max-width: 520px;
            width: calc(100% - 80px);
            border-radius: 28px;
            .slider{
                height: 48px;
                background: #1D1D1F;
                border-radius: 28px;
                transition: margin-left 0.3s, width 0.3s;
            }
        }
        .medium-box{
            position: absolute;
            top: 132px;
            left: 50%;
            transform: translateX(-50%);
            max-width: 960px;
            width: 100%;
            height: 324px;
            img{
                position: absolute;
                width: 100%;
                height: 100%;
                object-fit: cover;
                opacity: 0;
                transition: opacity 0.8s ease;
                &:nth-of-type(1){
                    z-index: 2;
                    opacity: 1;
                }
                &:nth-of-type(2){
                    z-index: 3;
                }
                &:nth-of-type(3){
                    z-index: 4;
                }
            }
            .play-btn{
                position: absolute;
                width: 136px;
                height: 48px;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                border-radius: 24px;
                z-index: 5;
                &:hover{
                    cursor: pointer;  
                }
            }
        }
        .bottom-box{
            position: absolute;
            top: 496px;
            padding: 0 40px;
            text-align: center;
            .title{
                height: 36px;
                font-weight: 500;
                font-size: 26px;
                color: #000000;
                line-height: 36px;
                text-align: center;
                margin-bottom: 15px;
                overflow-y: auto;
            }
            .content{
                max-width: 957px;
                width: 100%;
                height: 48px;
                font-weight: 400;
                font-size: 14px;
                color: #000000bf;
                text-align: center;
                line-height: 24px;
            }
        }
        .video-container{
            width: 100vw;
            height: 100vh;
            background: #00000099;
            position: fixed;
            z-index: 1200;
            top: 0;
            left: 0;
            
            .video-box{
                position: absolute;
                // max-width: 1280px;
                // width: 66.7%;
                // height: 720px;
                width: vw(1280);
                height: vh(790);
                // background: #666666;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                object-fit: contain;
                flex-shrink: 1;
            }

            .cancel-btn{
                max-width: 36px;
                max-height: 36px;
                position: absolute;
                top: 8.67%;
                left: 83.85%;
                &:hover{
                    cursor: pointer; 
                }
            }    
        }
    }
    .third-page{
        width: 100vw;
        height: 600vh;
        position: relative;
        padding: 0 40px;
        transition: transform 0.5s ease;
        z-index: 1;
        
        .top-box{
            position: absolute;
            left: 0;
            width: 100vw;
            height: 100vh;
            
            .title{
                position: absolute;
                width: 100vw;
                height: 60px;
                top: vh(70);
                font-weight: 500;
                font-size: 36px;
                color: #FFFFFF;
                text-align: center;
                line-height: 60px;
                z-index: 5;
            } 

            .control{
                position: absolute;
                width: 12px;
                height: 130px;
                left: auto;
                right: vw(40);
                top: 50%;
                transform: translateY(-50%);
                z-index: 5;

                .circle{
                    width: 8px;
                    height: 8px;
                    background: #ffffffa3;
                    border-radius: 4px;
                    margin-bottom: 16px;
                    transform: translateX(-50%);
                    transition: all 0.2s ease;

                    &:hover{
                        cursor: pointer;
                    }
                }
                .active{
                    width: 12px;
                    height: 12px;
                    background: #FFFFFF;
                    border: 1.5px solid #FFFFFF;
                    border-radius: 6px;
                    margin-bottom: 14px;
                }
            } 
            .backImg{
                width: 100vw;
                height: 100vh;
                position: absolute;
                background-image: linear-gradient(180deg, #000000 0%, #141638 100%);
                top: 0;
                z-index: 2;

            }
            .image-box{
                position: absolute;
                right: vw(240);
                top: vh(260);
                width: vw(780);
                height: vh(640);
                z-index: 3;
                object-fit: cover;
                object-position: center;
                overflow: hidden;


                .rightImg{
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    z-index: 3;
                    opacity: 0;
                    flex-shrink: 1;
                    transition: all 0.4s ease-in-out;
                }

                .rightImg_active{
                    z-index: 4;
                    opacity: 1;
                }
                
            }
        }
        .top_top{
            top:0;
            bottom: auto;
        }
        .top_fix{
            top: 0;
            position: fixed;
        }
        .top_bottom{
            bottom: 0;
            top: auto;
        }
        .box{
            width: vw(660);
            height: 100%;
            position: absolute;
            z-index: 4;
            left: vw(240);

            .box-background{
                width: vw(660);
                height: 100vh;
                position: relative;

                .item{
                    position: absolute;
                    top: vh(260);
                    left: 50%;
                    transform: translateX(-50%);
                    max-width: 1440px;
                    width: calc(100% - 80px);
                    height: vh(640);
                    // border: #FFFFFF 1px solid;
                    display: flex;
                    justify-content: space-between;
                    opacity: 0.4;
                    transition: opacity 0.2s ease;

                    .content-box{
                        width: vw(660);
                        justify-content: flex-start;
                        color: #FFFFFF;
                        .trigger{
                            width: 36px;
                            height: 3px;
                            background: #FFFFFF;
                            margin-top: vh(180);
                        }
                        .subtitle{
                            width: 100%;
                            height: 48px;
                            font-weight: 500;
                            font-size: 34px;
                            margin-top: 40px;
                            margin-bottom: 30px;
                            white-space: nowrap;
                        }
                        .content{
                            max-width: 540px;
                            width: 100%;
                            height: auto;
                            font-size: 18px;
                            line-height: 32px;
                            margin: 0;
                        }
                        .tag-box{
                            width: 100%;
                            height: 32px;
                            display: flex;
                            margin-top: 24px;
                            .tag{
                                margin-right: 24px;
                                border: 1px solid #FFFFFF;
                                border-radius: 20px;
                                padding: 2px 16px;
                                font-weight: 400;
                                font-size: 14px;
                                color: #FFFFFF;
                                text-align: center;
                                line-height: 28px;
                                white-space: nowrap;
                            }
                        }
                    }
                }
                .active{
                    opacity: 1;
                }
            }    
            @media (max-width: 600px) {
                .subtitle{
                }
            }
        }
    }
    .fourth-page{
        width: 100vw;
        height: 780px;
        position: relative;

        .title{
            width: 100%;
            height: 130px;
            font-weight: 500;
            font-size: 36px;
            text-align: center;
            line-height: 60px;
            padding-top: 70px;
        }
        .bottom-box{
            position: absolute;
            width: 100vw;
            height: 516px;
            bottom: 78px;
        }
    }
    .fifth-page{
        width: 100vw;
        height: auto;
        background-image: linear-gradient(180deg, #0F0225 0%, #141638 100%);
        padding: 70px 0  106px 0;

        .title{
            width: 100%;
            height: 60px;
            font-weight: 500;
            font-size: 36px;
            color: #FFFFFF;
            text-align: center;
            line-height: 60px;
            margin-bottom: 60px;
        }
        .image-box{
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items:center;

            .row{
                display: flex;
                justify-content:space-between;
                width: 100%;  
                max-width: 1336px ;
                margin-top: 36px;

                &:nth-of-type(1), {
                    max-width: 996px;
                    margin-top: 0px;
                }
                &:nth-of-type(4){
                    max-width: 996px;
                }

                .item{
                    height: 100%;
                    transition: transform 0.3s ease;

                    .image{
                        flex: 1;
                        max-height: 206px;
                        max-width: 146px;
                        width: 100%;
                        height: 100%;
                    }

                    &:hover{
                        transform: translateY(-12px);
                    }
                }
            }

            .more-btn{
                width: 160px;
                height: 40px;
                border: 1px solid #FFFFFF;
                border-radius: 24px;
                background-color: transparent;
                margin-top: 64px;

                .btn-content{
                    width: 56px;
                    height: 20px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                }
                .arrow-icon{
                    width: 12px;
                    height: 6px;
                    margin-left: 8px;
                }
                .svg-icon{
                    vertical-align: 0.1em;
                }
                
            }
        }
    }
}
</style>
